import { Navigate, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { supabase } from './components/supabaseClient'
import { CircularProgress, Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next' // Import i18next

export default function ProtectedRoute({ children }) {
  const { t } = useTranslation() // Hook for translations
  const location = useLocation()
  const [session, setSession] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchSession = async () => {
      const { data } = await supabase.auth.getSession()
      setSession(data.session)
      setLoading(false)
    }

    fetchSession()
  }, [])

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
        <Typography variant="body1" sx={{ ml: 2 }}>
          {t('loading')}
        </Typography>
      </Box>
    )
  }

  return session ? children : <Navigate to="/auth" state={{ from: location.pathname }} replace />
}
